import { transactionLedgerReference } from "@/utils/transactionLedgerReference.js";

/**
 * Linked internal P2P (member-to-member) transfer: withdrawal + deposit legs share
 * group_id / P2P external reference / API flags. Used for unified reference display
 * and POST .../transfer/reverse-p2p instead of single-leg reversal.
 *
 * @param {object|null|undefined} row
 * @returns {boolean}
 */
export function isLinkedP2pInternalTransfer(row) {
	if (!row || typeof row !== "object") {
		return false;
	}
	const mode = String(row.transaction_mode || "").trim();
	if (mode !== "Transfer") {
		return false;
	}
	const gid = row.group_id;
	if (gid != null && String(gid).trim() !== "") {
		return true;
	}
	const ext = row.external_reference;
	if (
		ext != null &&
		ext !== "" &&
		/^P2P-/i.test(String(ext).trim())
	) {
		return true;
	}
	if (row.p2p_linked === true || row.is_internal_p2p_pair === true) {
		return true;
	}
	return false;
}

/**
 * Prefer ledger_reference, then external_reference, then canonical TRA fallback.
 *
 * @param {object|null|undefined} row
 * @returns {string}
 */
export function p2pSharedBusinessReference(row) {
	if (!row || typeof row !== "object") {
		return "";
	}
	const lr = row.ledger_reference;
	if (lr != null && String(lr).trim() !== "") {
		return String(lr).trim();
	}
	const ext = row.external_reference;
	if (ext != null && String(ext).trim() !== "") {
		return String(ext).trim();
	}
	return transactionLedgerReference(row);
}
